import { useEffect, useState } from "react"
import { defaultCardSelection, GroupHeader, groupSelector, mainHeader, selectHeader, singleAnswerForm } from "./functions"

const options = [
  "Alumínio e Vidro",
  "Metálico",
  "Madeira",
  "Alvenaria",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
];

const GuardrailQuestions = ({ onGroupsChange, formData, preGroup, finished }) => {
  const [groups, setGroups] = useState([])
  const [currentGroup, setCurrentGroup] = useState([])
  const [formatPav, setFormatPav] = useState([])
  const [toggle, setToggle] = useState(true)
  const { guardrail } = formData.roomDefinitions
  const { pavements } = formData
  const [visibleGroups, setVisibleGroups] = useState([])

  const handleGroup = (e) => {
    if (finished) return;
    if (!currentGroup.includes(e)) {
      setCurrentGroup([...currentGroup, e])
    } else {
      setCurrentGroup(currentGroup.filter(i => i !== e))
    }
  }

  const finishGroup = () => {
    setGroups([...groups, { rooms: currentGroup.sort(), type: "", height: "" }])
    setCurrentGroup([])
  }

  useEffect(() => {
    onGroupsChange(groups)
  }, [groups])

  useEffect(() => {
    if (groups.length > 0) {
      const elem = document.getElementById(`guardacorpos-${groups.length - 1}`);
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [groups.length])

  const checkRemaining = (arr) => {
    const remaining = arr?.filter(i => !groups.flatMap(group => group.rooms).includes(i));
    return remaining;
  }

  const selectAll = () => {
    if (currentGroup.join('') === checkRemaining(guardrail).join('')) {
      setCurrentGroup([])
    } else {
      setCurrentGroup(checkRemaining(guardrail))
    }
  }

  useEffect(() => {
    const pavs = pavements.map(i => {
      return {
        pavement: i.pavement,
        rooms: i.rooms.filter(j => guardrail.includes(j))
      }
    })
    setFormatPav(pavs.filter(i => i.rooms.length > 0));
    setGroups(preGroup || [])
  }, [])

  const selectBulk = (priv) => {
    const privAreas = formData.roomDefinitions.privAreas.filter(i => guardrail.includes(i));
    if (priv) {
      setCurrentGroup(privAreas);
    } else {
      const common = guardrail.filter(i => !privAreas.includes(i)).filter(i => guardrail.includes(i))
      setCurrentGroup(common)
    }
  }

  const handleChanges = (e, idx, field) => {
    if (finished) return;
    const newGroups = [...groups];
    newGroups[idx][field] = e;
    setGroups(newGroups);
  }

  const resetGroup = (idx) => {
    const newGroups = [...groups];
    newGroups.splice(idx, 1);
    setGroups(newGroups);
    setCurrentGroup([]);
  }

  const resetAll = () => {
    setGroups([])
  }

  const handleToggle = (idx) => {
    if (visibleGroups.includes(idx)) {
      setVisibleGroups(visibleGroups.filter(i => i !== idx))
    } else {
      setVisibleGroups([...visibleGroups, idx])
    }
  }

  return <div className="form-section">
    {mainHeader("Guarda-corpo", groups, resetAll, toggle, setToggle)}

    {toggle && <>

      {groups.length > 0 && <>
        {groups.map((i, idx) => {
          return <div id={`guardacorpos-${idx}`} key={idx}>
              <GroupHeader idx={idx} rooms={i.rooms} handleToggle={handleToggle} active={visibleGroups.includes(idx)} groups={groups} setGroups={setGroups} setCurrentGroup={setCurrentGroup} />
            {visibleGroups.includes(idx) && <div className="group-questions-container">

              {singleAnswerForm("Qual material do guarda-corpo nesses ambientes?", options, idx, "type", formData.projRoomFull, "Materiais de Guarda-corpo", groups[idx], handleChanges, finished)}
            </div>}
          </div>
        })}
      </>}

      {checkRemaining(guardrail).length > 0 && <>
        <label className="margin-tier-2 select-groups-header">Selecionar grupos</label>
        {selectHeader(selectAll, selectBulk)}
      </>}

      {groupSelector(formatPav, groups, currentGroup, handleGroup, finishGroup, guardrail)}
    </>}
  </div>
}

export default GuardrailQuestions;